import { render, staticRenderFns } from "./Tuitionandfees.vue?vue&type=template&id=1ccba7ad"
import script from "./Tuitionandfees.vue?vue&type=script&lang=js"
export * from "./Tuitionandfees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports